import "ag-grid-enterprise";
import "ag-grid-enterprise/styles/ag-grid.min.css";
import "ag-grid-enterprise/styles/ag-theme-balham.min.css";
import "index.css";

import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "serviceWorker";
import App from "App";
import patchComparison from "./patchComparison";

if (process.env.NODE_ENV === "development") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

patchComparison();

(async () => {
  ReactDOM.render(<App />, document.getElementById("root"));
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
})();
